// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table.user-table{background:#fff}table.user-table thead{background:#fff}", "",{"version":3,"sources":["webpack://./src/components/employer/manageUsers/style.scss"],"names":[],"mappings":"AAAA,iBACI,eAAA,CACA,uBACI,eAAA","sourcesContent":["table.user-table {\n    background: #fff;\n    thead {\n        background: #fff;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
